module.exports = __webpack_public_path__ + "static/media/b-icon.04982e79.svg";